module.exports = __webpack_public_path__ + "img/Bodice-Front-B6-Gb-Da-Eb.21feb709.png";